// extracted by mini-css-extract-plugin
export default {"chart_wrapper":"Chart_chart_wrapper__93ozk","chart":"Chart_chart__yIO4E","interval_section":"Chart_interval_section__yEqVp","interval_button":"Chart_interval_button__G82G4"};